<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-11-03 17:10:00
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2022-12-30 17:42:48
-->
<template>
	<div style="display: inline-block">
		<template v-if="userTypesList.length">
			<span v-for="item in userTypesList" :key="item.type" class="role-label mt-6 fl mr-2">{{ item.name }}</span>
		</template>
		<span v-else>-</span>
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin.js';
import { tzRoleType } from '@/utils/dataMap';
export default {
	name: 'LabelCell',
	mixins: [mixin],
	data() {
		return {};
	},
	computed: {
		userTypesList({ row }) {
			return row?.userTypes?.filter(v => v.type !== tzRoleType.id) || [];
		},
	},
	props: {},
	components: {},

	mounted() {},

	methods: {},
};
</script>
<style lang="less" scoped>
.fl {
	float: left;
}
</style>
